import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
} from "class-validator"
import { getNestedValue } from "../getNestedPath"

export function IsUnder(
  propertyPath: string,
  validationOptions?: ValidationOptions,
) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: "isUnder",
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [propertyPath],
      validator: {
        validate(value: any, args: ValidationArguments) {
          let relatedValue = getNestedValue(args.object, propertyPath)
          relatedValue = Number(relatedValue)

          // Only validate if the related value is a number
          if (typeof relatedValue !== "number" || isNaN(relatedValue))
            return true

          return value >= relatedValue
        },
        defaultMessage(args: ValidationArguments) {
          const [relatedPropertyPath] = args.constraints
          return `${args.property} must be less than or equal to ${relatedPropertyPath}`
        },
      },
    })
  }
}
